export var clans = {
    /* Set in app_settings, forwarded through clans/views.py and clans/templates/clans/base.html */
    /* also forwarded through accounts/views.py and templates/accounts/show.html */
    ASYNC_PROXY_URL: null,
    ENDPOINT_MAP: null,
};

var DROPDOWN_CLASS_NAME = 'list-box_dropdown';
var DROPDOWN_SELECTOR = '.' + DROPDOWN_CLASS_NAME;
var DROPDOWN_ACTIVATOR_CLASS = 'list-box_dropdown-activator';
var DROPDOWN_ACTIVATOR_SELECTOR = '.' + DROPDOWN_ACTIVATOR_CLASS;
var DROPDOWN_ACTIVATOR_CELL_CLASS = 'activator';
var DROPDOWN_ACTIVATOR_CELL_SELECTOR = '.' + DROPDOWN_ACTIVATOR_CELL_CLASS;
var DROPDOWN_ACTIVE_CLASS = 'active';
var DROPDOWN_ACTIVE_SELECTOR = '.' + DROPDOWN_ACTIVE_CLASS;
var DROPDOWN_ITEM_DISABLED_CLASS = 'list-box_dropdown_item__disabled';
var LISTBOX_SELECTOR = '.list-box';
var NONE_ROW_SELECTOR = '.js-list-box-none-row';
var LIST_ITEM_SELECTOR = '> table > tbody > tr';


var FORM_NAME_PREFIX = 'clan_field-'; // also specified in views.py:BaseView
var NAME_VALIDATION_SELECTOR = '.js-clans_name_validation.invalid';
var TAG_VALIDATION_SELECTOR = '.js-clans_tag_validation.invalid';

/* Console specifics */
var DROPDOWN_LIST_CONSOLE_CLASS = DROPDOWN_CLASS_NAME + '__console';
var LISTBOX_ICON_CONSOLE_CLASS = 'list-box__console';

clans.FORMS_BUTTON_DISABLED_CLASS = 'forms_button__disabled';
clans.FORMS_BUTTON_DISABLED_SELECTOR = '.' + clans.FORMS_BUTTON_DISABLED_CLASS;

var menuId = 0;

var $body;
var $window = $(window);

$(function () {
    $body = $('body');

    if (clans.is_console)
        $(LISTBOX_SELECTOR).addClass(LISTBOX_ICON_CONSOLE_CLASS);

});

$.fn.addListBoxDropDown = function (menuItems) {
    var $listItem = this;
    var hideDropDowns = function (ev) {
        if (ev && (
            !!$(ev.target).closest(DROPDOWN_ACTIVATOR_SELECTOR).length || !!$(ev.target).closest(DROPDOWN_SELECTOR).length)
        )
            return;

        $(DROPDOWN_SELECTOR).hide().closest('td').removeClass(DROPDOWN_ACTIVE_CLASS);
        $body.off('mousedown touchstart', hideDropDowns);
    };

    if (Object.keys(menuItems).length > 0) {
        var $menu = $('<ul>').addClass(DROPDOWN_CLASS_NAME);
        if (clans.is_console)
            $menu.addClass(DROPDOWN_LIST_CONSOLE_CLASS);
    } else {
        console.warn("Attempt to create a menu zero options.");
        return
    }

    function createMenuItem(menuItem) {

        var title = menuItem.title;
        var handler = menuItem.handler;
        var disabled = menuItem.disabled;
        var tooltip = menuItem.tooltip;


        var itemId = 'js-clans-dropdown-item-' + menuId++;
        var item = $('<a href="#">');
        item.text(title);

        if (disabled) {
            item.addClass(DROPDOWN_ITEM_DISABLED_CLASS).on('click tap', function (ev) {
                ev.preventDefault();
            });
        } else {
            item.on('click tap', function (ev) {
                ev.preventDefault();
                hideDropDowns();
                handler($listItem);
            });
        }
        if (tooltip) {
            item.attr('id', itemId).addClass('js-mobile-tooltip');
            item.append($('<div>').attr('id', itemId + '_tooltip').addClass('tooltip js-mobile-tooltip').text(tooltip));
        }

        return $('<li>').append(item);
    }

    for (var key in menuItems) {
        var value = menuItems[key];
        (function (menuItem) {
            $menu.append(createMenuItem(menuItem));
        })(value);
    }
    $menu.hide();

    var $activator = $('<span>')
        .addClass(DROPDOWN_ACTIVATOR_CLASS)
        .on('click', function (ev) {
            var $this = $(this);
            if ($this.closest('td').is(DROPDOWN_ACTIVE_SELECTOR)) {
                hideDropDowns();
            } else {
                hideDropDowns();
                $body.on('mousedown touchstart', hideDropDowns);
                $this.closest('td').addClass(DROPDOWN_ACTIVE_CLASS);

                $menu.show();
            }
        })
        .append($('<img>')
            .addClass('svg-icon js-svg-icon')
            .attr('data-src', STATIC_URL + "portal/img/svg-icons/clans/dropdown.svg")
            .attr('title', 'commands')
        );
    var dropdownCell;
    dropdownCell = $listItem.children(DROPDOWN_ACTIVATOR_CELL_SELECTOR);
    if (dropdownCell.length == 0) {
        $listItem.closest('table').find('tr').append($('<td>').addClass(DROPDOWN_ACTIVATOR_CELL_CLASS));
        dropdownCell = $listItem.children(DROPDOWN_ACTIVATOR_CELL_SELECTOR);
    }
    dropdownCell.append($activator, $menu);
};


$.fn.removeItem = function () {
    var $listItem = this;
    var $listBox = $listItem.closest(LISTBOX_SELECTOR);
    $listItem.remove();
    $listBox.find(NONE_ROW_SELECTOR).toggle($listBox.find(LIST_ITEM_SELECTOR).length == 0);
};


clans.showErrorFromApiResponse = function (data) {
    wg_errors.showError(wg_ui.getErrorString(data));
};


clans.isChanged = function ($element, doTrim) {
    switch ($element.attr('type')) {
        case "radio":
            var $formElementsWithSameName = $element.closest('form').find(':input').filter(function () {
                return $(this).attr('name') == $element.attr('name');
            });
            return $formElementsWithSameName.filter(':checked').filter(function () {
                return $(this).prop('defaultChecked');
            }).length == 0;

        case "text":
            return (doTrim ? $element.val().trim() : $element.val()) != $element.prop('defaultValue');
        default:
            console.error("No implementation of isChanged for element " + $element);
    }
};


clans.getFormFieldSelector = function (fieldName) {
    return '[name=' + FORM_NAME_PREFIX + fieldName + ']';
};

clans.validateClan = function ($validationList, $nameField, $tagField, $recruitingPolicyField) {

    if ($nameField.val() == "") {
        $validationList.append($('<li>').text(gettext("Name cannot be empty")));
    }

    var $nameValidationErrors = $(NAME_VALIDATION_SELECTOR);
    if ($nameValidationErrors.length > 0) {
        $nameValidationErrors.each(function () {
            $validationList.append($('<li>').append($(this).clone().children()));
        });
    }

    var $tagValidationErrors = $(TAG_VALIDATION_SELECTOR);
    if ($tagValidationErrors.length > 0) {
        $tagValidationErrors.each(function () {
            $validationList.append($('<li>').append($(this).clone().children()));
        });
    }
    if ($tagField.val().length < 2) {
        $validationList.append($('<li>').text(gettext("Tag must be at least 2 characters")));
    }
    if ($recruitingPolicyField.filter(':checked').length == 0) {
        $validationList.append($('<li>').text(gettext("A recruiting policy must be selected")));
    }
    return $validationList;
};

clans.callEndpoint = function (settings) {
    settings.endpoint = clans.ENDPOINT_MAP[settings.endpoint];
    settings.asyncResultEndpoint = clans.ASYNC_PROXY_URL;
    settings.accountId = clans.account_id;
    settings.asyncResultHandler = function (data) {
        switch (parseInt(data.result)) {
            case 0: // Success
                return wg_ui.ENDPOINT_RESULT_SUCCESS;
            case 2: // Not enough gold
                return gettext("There is not enough gold in this account.");
            case 1: // Error
            // FUTURE: Arguably we could handle errors better with some sort of dynamic error lookup
            // So far there has been little need.
            default:
                return wg_ui.ENDPOINT_RESULT_FAILURE
        }
    };
    return wg_ui.callEndpoint(settings);
};
